// src/pages/HistorialClinico.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import Topbar from '../components/Topbar';
import Breadcrumb from '../components/Breadcrumb';
import '../styles/HistorialClinico.css';
import { ToastContainer, toast } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import ModalConfirmacion from "../components/ModalConfirmacion";
import { Link } from 'react-router-dom';

export default function HistorialClinico() {
  const { expediente } = useParams();
  const history = useHistory();
  const [actuaciones, setActuaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [seleccionados, setSeleccionados] = useState([]);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [nuevaFila, setNuevaFila] = useState(null);
  const [tratamientosDisponibles, setTratamientosDisponibles] = useState([]);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [mensajeModal, setMensajeModal] = useState("");
  const [accionPendiente, setAccionPendiente] = useState(null);
  const [paciente, setPaciente] = useState(null);

  const actuacionesSeleccionadas = actuaciones.filter(act =>
    seleccionados.includes(act.id)
  );


  const toggleSeleccion = (id) => {
    setSeleccionados(prev =>
      prev.includes(id)
        ? prev.filter(sel => sel !== id)
        : [...prev, id]
    );
  };

  const confirmarGuardar = () => {
/*     const tieneFactura = actuaciones.some(
      act => seleccionados.includes(act.id) && act.n_factura
    );
    if (tieneFactura) {
      setMensajeModal("Estas actuaciones ya están facturadas. Si guardas los cambios se generará una FACTURA RECTIFICATIVA. ¿Deseas continuar?");
      setAccionPendiente(() => () => confirmarConFactura("RECTIFICATIVA"));
      setModalAbierto(true);
    } else { */
      guardarCambios();
    /*  }*/
  };

  const confirmarEliminar = () => {
    const tieneFactura = actuaciones.some(
      act => seleccionados.includes(act.id) && act.n_factura
    );
    if (tieneFactura) {
      setMensajeModal("Estas actuaciones ya están facturadas. Si las eliminas se generará una FACTURA ANULADA. ¿Deseas continuar?");
      setAccionPendiente(() => () => confirmarConFactura("ANULADA"));
      setModalAbierto(true);
    } else {
      handleEliminar();
    }
  };

  const actualizarCampo = (id, campo, valor) => {
    setActuaciones(prev =>
      prev.map(act =>
        act.id === id ? { ...act, [campo]: valor } : act
      )
    );
  };

  const guardarCambios = async () => {
    try {
      // 1. Actualizar actuaciones existentes
      const actualizables = actuaciones.filter(act => seleccionados.includes(act.id));
      await axios.put('/api/actuaciones', actualizables, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });

      // 2. Crear nueva fila si existe
      if (nuevaFila) {
        await axios.post('/api/actuaciones', nuevaFila, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
      }

      // 3. Recargar datos
      const { data } = await axios.get(`/api/actuaciones/paciente/${expediente}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setActuaciones(data);
      setSeleccionados([]);
      setModoEdicion(false);
      setNuevaFila(null);
    } catch (err) {
      console.error('Error al guardar cambios', err.response || err);
    }
  };

  const handleGuardarNueva = async () => {
    try {
      if (!nuevaFila.tratamiento) {
        toast.error("Falta el tratamiento, asegurate de seleccionarlo");
        return;
      } else if (!nuevaFila.dia) {
        toast.error("Falta la fecha");
        return;
      }
      const { data: nuevaActuacion } = await axios.post(`/api/actuaciones/paciente/${expediente}`, nuevaFila, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });

      setActuaciones([...actuaciones, nuevaActuacion]);
      setNuevaFila(null);
      toast.success(`Actuación guardada con ID: ${nuevaActuacion.id}`, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
    } catch (error) {
      console.error("Error al guardar la actuación", error.response || error);
    }
  };

  const handleEliminar = async () => {
    const confirmacion = window.confirm("¿Estás seguro de que quieres eliminar las actuaciones seleccionadas?");
    if (!confirmacion) return;

    try {
      await axios.delete('/api/actuaciones', {
        data: { ids: seleccionados },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });

      toast.success("Actuaciones eliminadas correctamente");
      const { data } = await axios.get(`/api/actuaciones/paciente/${expediente}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      setActuaciones(data);
      setSeleccionados([]);
    } catch (error) {
      toast.error("Error al eliminar actuaciones");
      console.error("Error al eliminar", error.response || error);
    }
  };

  const confirmarConFactura = (estado_factura) => {
    const actuacionesSeleccionadas = actuaciones.filter(act =>
      seleccionados.includes(act.id)
  );

  const items = actuacionesSeleccionadas.map(act => ({
      id: act.id,
      fecha: act.dia || new Date().toLocaleDateString('es-ES'),
      clave: act.clave,
      tratamiento: act.tratamiento,
      pieza: act.n_pieza,
      cuadrante: act.cuadrante,
      arcada: act.arcada,
      cantidad: act.cantidad || 1,
      precioUnitario: act.importe,
      total: (act.cantidad || 1) * (act.importe || 0)
    }));

    const datosFacturacion = {
      n_expediente: expediente,
      clinica: "ELIPA", // o VEN, según lógica que uses
      items,
      total: items.reduce((acc, i) => acc + i.total, 0),
      fecha: new Date().toISOString().slice(0, 10),
      nombreCliente: expediente?.pacienteNombre || "Paciente",
      nif: expediente?.pacienteNif || "NIF",
      nifEmisor: "B88084215",
      estado_factura // "RECTIFICATIVA" o "ANULADA"
    };

    axios.post("/api/facturacion/emitir", datosFacturacion, {
      responseType: "blob",
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
    })
    .then(res => {
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/pdf" })
      );
      window.open(url, "_blank");
      toast.success(`Factura ${estado_factura} generada correctamente`);
    })
    .catch(err => {
      console.error("Error al generar factura:", err);
      toast.error("Error al generar factura");
    });
  };

  useEffect(() => {
    async function fetchHistorial() {
      try {
        const { data } = await axios.get(
          `/api/actuaciones/paciente/${expediente}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        );
        setActuaciones(data);
      } catch (err) {
        console.error('Error al cargar historial', err.response || err);
      } finally {
        setLoading(false);
      }
    }

    fetchHistorial();
  }, [expediente]);


  useEffect(() => {
    async function fetchTratamientos() {
      try {
        const { data } = await axios.get('/api/tratamientos', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        const opciones = data.map(t => ({
          value: t.nTratamiento,
          label: `${t.denominacion} - ${t.importe.toFixed(2)} €`,
          denominacion: t.denominacion,
          importe: t.importe
        }));
        setTratamientosDisponibles(opciones);
      } catch (err) {
        console.error('Error al cargar tratamientos', err.response || err);
      }
    }

      fetchTratamientos();
  }, []);

  useEffect(() => {
    async function fetchPaciente() {
      try {
        const { data } = await axios.get(`/api/pacientes/${expediente}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        setPaciente(data);
      } catch (err) {
        console.error("Error al cargar paciente:", err);
      }
    }

    fetchPaciente();
  }, [expediente]);

  if (loading) return <p>Cargando historial clínico…</p>;
  return (
    <>
      <ToastContainer />
      <Topbar />
      <div className="historial-clinico-page">
      <Breadcrumb />
        <h2>Historial Clínico del Paciente {expediente}</h2>
        <div className="acciones-superiores">
          <button
            className="accion-btn"
            disabled={seleccionados.length === 0}
            onClick={() => setModoEdicion(true)}
          >
            Editar
          </button>
          <button
            className="accion-btn"
            onClick={() => setNuevaFila(true)}
          >
            Añadir
          </button>
          {modoEdicion && (
            <button
              className="accion-btn guardar"
              onClick={confirmarGuardar}
            >
              Guardar cambios
            </button>
          )}
          {nuevaFila && (
            <button 
              className="accion-btn guardar"
              onClick={handleGuardarNueva}>
                Guardar
            </button>
          )}
          {(modoEdicion || nuevaFila) && (
            <button
              className="accion-btn cancelar"
              onClick={() => {
                setModoEdicion(false);
                setNuevaFila(null);
                setSeleccionados([]);
              }}
            >
              Cancelar
            </button>
          )}
          <button
            className="accion-btn eliminar"
            disabled={seleccionados.length === 0}
            onClick={handleEliminar}
          >
            Eliminar
          </button>
        </div>
        <table className="historial-table">
            <thead>
              <tr>
                  <th></th>
                  <th>ID</th>
                  <th>Día</th>
                  <th>Tratamiento</th>
                  <th>Observaciones</th>
                  <th>Pieza</th>
                  <th>Cuadrante</th>
                  <th>Arcada</th>
                  <th>Cantidad</th>
                  <th>Realizado</th>
                  <th>Facturado</th>
                  <th>Pendiente</th>
                  <th>Presupuesto</th>
              </tr>
            </thead>
            <tbody>
              {actuaciones.map(act => {
                const enEdicion = modoEdicion && seleccionados.includes(act.id);
                return (
                  <tr key={act.id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={seleccionados.includes(act.id)}
                        onChange={() => toggleSeleccion(act.id)}
                      />
                    </td>
                    {enEdicion ? (
                      <>
                        <td>{act.id}</td>
                        <td> <input className="input-campo" type="date" value={act.dia} onChange={e => actualizarCampo(act.id, 'dia', e.target.value)} /></td>
                        <td>
                          <Select
                            options={tratamientosDisponibles}
                            value={tratamientosDisponibles.find(opt => opt.value === act.tratamiento)}
                            onChange={(opcion) => {
                              actualizarCampo(act.id, 'n_tratamiento', opcion.value);
                              actualizarCampo(act.id, 'tratamiento', opcion.label);
                              actualizarCampo(act.id, 'importe', opcion.importe);
                            }}
                            placeholder="Seleccionar tratamiento"
                            isClearable
                          />
                        </td>
                        <td><input className="input-campo" value={act.incidencias} onChange={e => actualizarCampo(act.id, 'incidencias', e.target.value)} /></td>
                        <td><input className="input-campo" value={act.n_pieza} onChange={e => actualizarCampo(act.id, 'n_pieza', e.target.value)} /></td>
                        <td><input className="input-campo" value={act.cuadrante} onChange={e => actualizarCampo(act.id, 'cuadrante', e.target.value)} /></td>
                        <td><input className="input-campo" value={act.arcada} onChange={e => actualizarCampo(act.id, 'arcada', e.target.value)} /></td>
                        <td><input className="input-campo" value={act.cantidad} onChange={e => actualizarCampo(act.id, 'cantidad', e.target.value)} /></td>
                        <td><input className="input-campo" type="checkbox" checked={act.realizado} onChange={e => actualizarCampo(act.id, 'realizado', e.target.checked ? 1 : 0)} /></td>
                        <td>{act.n_factura ? 'Sí' : 'No'}</td>
                        <td><input className="input-campo" value={act.pendiente_pago} onChange={e => actualizarCampo(act.id, 'pendiente_pago', e.target.value)} /></td>
                        <td><input className="input-campo" value={act.n_presupuesto} onChange={e => actualizarCampo(act.id, 'n_presupuesto', e.target.value)} /></td>
                      </>
                    ) : (
                      <>
                        <td>{act.id}</td>
                        <td>{act.dia}</td>
                        <td>{tratamientosDisponibles.find(t => t.value === act.tratamiento)?.label || act.tratamiento}</td>
                        <td>{act.incidencias}</td>
                        <td>{act.n_pieza}</td>
                        <td>{act.cuadrante}</td>
                        <td>{act.arcada}</td>
                        <td>{act.cantidad}</td>
                        <td>
                            <span className={act.realizado ? 'color-si' : 'color-no'}>
                                {act.realizado ? 'Sí' : 'No'}
                            </span>
                        </td>
                        <td>
                            <span className={act.n_factura ? 'color-si' : 'color-no'}>
                                {act.n_factura ? 'Sí' : 'No'}
                            </span>
                        </td>
                        <td>{act.pendiente_pago}</td>
                        <td>{act.n_presupuesto}</td>
                      </>
                    )}
                  </tr>
                );
              })}

              {nuevaFila && (
                <tr key="nueva">
                  <td></td>
                  <td>Nuevo</td>
                  <td><input className="input-campo" type="date" value={nuevaFila.dia} onChange={e => setNuevaFila({ ...nuevaFila, dia: e.target.value })} /></td>
                  <td>
                    <Select
                      options={tratamientosDisponibles}
                      value={tratamientosDisponibles.find(opt => opt.value === nuevaFila.tratamiento)}
                      onChange={(opcion) => {
                        setNuevaFila(prev => ({
                          ...prev,
                          n_tratamiento: opcion.value,
                          tratamiento: opcion.label,
                          importe: opcion.importe,
                        }));
                      }}
                      placeholder="Seleccionar tratamiento"
                      isClearable
                    />
                  </td>
                  <td><input className="input-campo" value={nuevaFila.incidencias} onChange={e => setNuevaFila({ ...nuevaFila, incidencias: e.target.value })} /></td>
                  <td><input className="input-campo" value={nuevaFila.n_pieza} onChange={e => setNuevaFila({ ...nuevaFila, n_pieza: e.target.value })} /></td>
                  <td><input className="input-campo" value={nuevaFila.cuadrante} onChange={e => setNuevaFila({ ...nuevaFila, cuadrante: e.target.value })} /></td>
                  <td><input className="input-campo" value={nuevaFila.arcada} onChange={e => setNuevaFila({ ...nuevaFila, arcada: e.target.value })} /></td>
                  <td><input className="input-campo" value={nuevaFila.cantidad} onChange={e => setNuevaFila({ ...nuevaFila, cantidad: e.target.value })} /></td>
                  <td><input className="input-campo" type="checkbox" checked={nuevaFila.realizado} onChange={e => setNuevaFila({ ...nuevaFila, realizado: e.target.checked ? 1 : 0})} /></td>
                  <td></td>
                  <td><input className="input-campo" value={nuevaFila.pendiente_pago} onChange={e => setNuevaFila({ ...nuevaFila, pendiente_pago: e.target.value })} /></td>
                  <td><input className="input-campo" value={nuevaFila.n_presupuesto} onChange={e => setNuevaFila({ ...nuevaFila, n_presupuesto: e.target.value })} /></td>
                </tr>
              )}
            </tbody>
        </table>      
        <div className="acciones-inferiores">
          <button
            className="accion-btn odontograma"
            onClick={() => history.push(`/pacientes/${expediente}/odontograma`)}
          >
            Odontograma
          </button>
          <button
            className="accion-btn presupuesto"
            disabled={seleccionados.length === 0}
            onClick={() => {
              const seleccionadas = actuaciones.filter(act => seleccionados.includes(act.id));
              history.push(`/presupuesto`, { actuaciones: seleccionadas, expediente: expediente });
            }}
          >
            Realizar presupuesto
          </button>
{/*           <button
            className="accion-btn estado"
            disabled={seleccionados.length === 0}
            onClick={() => console.log('Estado de tratamientos')}
          >
            Estado de tratamientos
          </button> */}
          <button
            className="accion-btn facturar"
            disabled={seleccionados.length === 0}
            onClick={() => {
              const seleccionadas = actuaciones.filter(act => seleccionados.includes(act.id));
              history.push(`/facturacion`, { 
                actuaciones: seleccionadas, 
                expediente,
                pacienteNombre: `${paciente?.nombre} ${paciente?.primer_apellido} ${paciente?.segundo_apellido}`.trim(),
                pacienteNif: paciente.nif
              });
            }}
          >
            Facturar
          </button>
          <button
            className="volver-btn"
            onClick={() => history.push(`/pacientes/${expediente}`)}
          >
            Volver al paciente
          </button>
        </div>
      </div>
      <ModalConfirmacion
        abierto={modalAbierto}
        mensaje={mensajeModal}
        onConfirmar={() => {
          setModalAbierto(false);
          if (accionPendiente) accionPendiente();
        }}
        onCancelar={() => setModalAbierto(false)}
      />
    </>
  );
}
